<template>
  <v-container fluid fill-height class="communication-books-page pa-0 d-flex flex-column">
    <FullHeader />
    <div class="communication-books-content">
      <div class="communications-toolbar-row">
        <v-btn-toggle class="communications-view-toggle" v-if="!$vuetify.breakpoint.mobile">
          <GlobalNewButton class="mr-2"/>
          <v-btn class="custom-button-consultas" :class="view === 'folios' ? 'selected' : ''" tile
            :disabled="!checkPermissions(['view_communication_books'])"
            @click="view = 'folios'">
            <div class="d-flex align-start">
              <v-icon>mdi-book-open-page-variant-outline</v-icon>
              <div class="ml-2">
                <p class="mb-0 font-weight-bold text-capitalize">Libros</p>
                <p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Folios</p>
              </div>
            </div>
          </v-btn>
          <v-btn class="custom-button-consultas" :class="view === 'drafts' ? 'selected' : ''" tile
            :disabled="!checkPermissions(['view_communication_books'])"
            @click="view = 'drafts'">
            <div class="d-flex align-start">
              <v-icon>mdi-file-document-edit-outline</v-icon>
              <div class="ml-2">
                <p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
                <p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
              </div>
            </div>
          </v-btn>
        </v-btn-toggle>
        <v-menu offset-y v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              color="#2D4B95"
              dark
              small
              block
              v-bind="attrs"
              v-on="on"
            >
              Seleccione Acción
            </v-btn>
          </template>
          <div class="d-flex flex-column pa-2 white" style="gap: 5px;">
            <GlobalNewButton :fullWidth="true"/>
            <v-btn v-if="selectedProject && (canAdminBooks || canAdminCodes)" class="custom-button-consultas" tile @click="adminModal = true">
              <v-icon>mdi-book-cog-outline</v-icon>
              <span class="ml-2">Administrar</span>
            </v-btn>
            <v-divider class="my-1"></v-divider>
            <v-btn class="custom-button-consultas" :class="view === 'folios' ? 'selected' : ''" tile
              :disabled="!checkPermissions(['view_communication_books'])"
              @click="view = 'folios'">
              <div class="d-flex align-start">
                <v-icon>mdi-book-open-page-variant-outline</v-icon>
                <div class="ml-2">
                  <p class="mb-0 font-weight-bold text-capitalize">Libros</p>
                  <p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Folios</p>
                </div>
              </div>
            </v-btn>
            <v-btn class="custom-button-consultas" :class="view === 'drafts' ? 'selected' : ''" tile
              :disabled="!checkPermissions(['view_communication_books'])"
              @click="view = 'drafts'">
              <div class="d-flex align-start">
                <v-icon>mdi-file-document-edit-outline</v-icon>
                <div class="ml-2">
                  <p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
                  <p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
                </div>
              </div>
            </v-btn>
          </div>
        </v-menu>

        <div v-if="view === 'folios'" class="book-controls">
          <v-btn
            v-if="selectedProject && (canAdminBooks || canAdminCodes)"
            class="custom-button-consultas book-admin-button"
            small
            tile
            @click="adminModal = true"
          >
            <v-icon>mdi-book-cog-outline</v-icon>
            <span class="ml-2">Administrar</span>
          </v-btn>
          <FilterMenu
            v-model="bookFilterSelection"
            :items="bookFilterItems"
            :item-text="bookFilterText"
            item-value="id"
            label="Filtrar por Libros"
            list-title="Filtrar Folios por Libro"
            :search-enabled="true"
            search-placeholder="Buscar Libro..."
            :max-height="320"
            :activator-loading="loadingBooks"
            activator-icon="mdi-filter-variant"
            activator-class="custom-button-consultas book-filter-trigger"
            :activator-text="false"
            :compact-activator="true"
            activator-style="width: 180px; min-width: 180px; max-width: 180px;"
            @apply="applyBookFilter"
          />
          <v-btn
            v-if="canOpenSelectedBook"
            class="custom-button-consultas opening-button"
            small
            tile
            @click="openOpeningFolio"
          >
            <v-icon small>mdi-book-plus-outline</v-icon>
            <span class="ml-2">Crear Folio 1</span>
          </v-btn>
          <v-btn
            icon
            :loading="loadingFolios"
            title="Actualizar Folios"
            @click="loadFolios"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </div>

      <v-card v-if="view === 'folios'" outlined class="communication-books-list-card">
        <v-alert v-if="error" type="error" text class="ma-4">
          No fue posible cargar los Libros/Folios.
        </v-alert>
        <v-progress-linear v-if="loadingFolios" indeterminate color="primary" />

        <v-simple-table v-if="!loadingFolios && folios.length" class="communication-books-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Asunto</th>
              <th>Urgencia</th>
              <th>Estado</th>
              <th>Publicado por</th>
              <th>Fecha</th>
              <th class="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="folio in folios" :key="folio.id" @click="openFolio(folio)">
              <td class="font-weight-bold text-primary">{{ folio.code }}</td>
              <td>{{ folio.title }}</td>
              <td><v-chip x-small :color="priorityColor(folio.priority)">{{ priorityLabel(folio.priority) }}</v-chip></td>
              <td>
                <v-chip x-small :color="folio.status === 'finished' ? 'grey lighten-2' : 'green lighten-5'">
                  {{ folio.status === 'finished' ? 'Finalizado' : 'Publicado' }}
                </v-chip>
              </td>
              <td>{{ publisherName(folio) }}</td>
              <td>{{ formatDate(folio.published_at) }}</td>
              <td class="text-right">
                <v-btn icon small title="Ver Folio" @click.stop="openFolio(folio)">
                  <v-icon small>mdi-eye-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div v-else-if="!loadingFolios && selectedBook" class="empty-state">
          <v-icon size="42" color="grey lighten-1">mdi-book-open-page-variant-outline</v-icon>
          <p class="subtitle-1 mb-1">No hay Folios para este Libro</p>
          <p class="body-2 text--secondary mb-0">Crea el primer Folio publicado para comenzar.</p>
        </div>
        <div v-else-if="!loadingBooks" class="empty-state">
          <v-icon size="42" color="grey lighten-1">mdi-book-lock-outline</v-icon>
          <p class="subtitle-1 mb-1">No hay Libros disponibles</p>
          <p class="body-2 text--secondary mb-0">El proyecto activo no tiene un Libro habilitado.</p>
        </div>

        <div v-if="lastPage > 1" class="d-flex justify-center pa-4">
          <v-pagination v-model="page" :length="lastPage" total-visible="7" @input="loadFolios" />
        </div>
      </v-card>

      <ListadoBorradores
        v-else-if="selectedProject"
        :draft-type="15"
        @loadDraft="loadDraft"
      />
    </div>
    <CommunicationBooksAdminModal
      v-if="adminModal"
      :project-id="selectedProject.id"
      :can-manage-books="canAdminBooks"
      :can-manage-codes="canAdminCodes"
      @close="closeAdminModal"
    />
  </v-container>
</template>

<script>
import FullHeader from '@/components/Globals/Headers/FullHeader'
import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'
import ListadoBorradores from '@/components/Globals/Helpers/ListadoBorradores'
import FilterMenu from '@/components/Globals/Helpers/FilterMenu'
import CommunicationBooksAdminModal from '@/components/Globals/Modals/Communications/CommunicationBooksAdminModal'

export default {
  name: 'CommunicationBooksIndex',
  components: { FullHeader, GlobalNewButton, ListadoBorradores, FilterMenu, CommunicationBooksAdminModal },
  data: () => ({
    page: 1,
    view: 'folios',
    adminModal: false,
  }),
  computed: {
    selectedProject() {
      return this.$store.projectsStore.state.selectedProject
    },
    canAdminBooks() {
      return this.checkPermissions(['manage_communication_books'])
    },
    canAdminCodes() {
      return this.checkPermissions(['create_communication_book_codes'])
    },
    books() {
      return this.$store.communicationBooksStore.state.books
    },
    selectedBookId: {
      get() {
        return this.$store.communicationBooksStore.state.selectedBookId
      },
      set(value) {
        this.$store.communicationBooksStore.commit('setSelectedBookId', value)
        this.page = 1
        this.loadFolios()
      },
    },
    selectedBook() {
      return this.books.find(book => book.id === this.selectedBookId) || null
    },
    selectedBookFilterIds() {
      return this.$store.communicationBooksStore.state.selectedBookFilterIds
    },
    bookFilterItems() {
      return [{ id: 'all', name: 'Todos' }].concat(this.books)
    },
    bookFilterSelection: {
      get() {
        return this.selectedBookFilterIds.length ? this.selectedBookFilterIds : ['all']
      },
      set(value) {
        const selected = Array.isArray(value) ? value : []
        const normalized = selected.includes('all')
          ? selected.filter(bookId => bookId !== 'all')
          : selected
        this.$store.communicationBooksStore.commit(
          'setSelectedBookFilterIds',
          normalized
        )
      },
    },
    folios() {
      return this.$store.communicationBooksStore.state.folios.data || []
    },
    lastPage() {
      return this.$store.communicationBooksStore.state.folios.last_page || 1
    },
    loadingBooks() {
      return this.$store.communicationBooksStore.state.loadingBooks
    },
    loadingFolios() {
      return this.$store.communicationBooksStore.state.loadingFolios
    },
    error() {
      return this.$store.communicationBooksStore.state.error
    },
    accessDenied() {
      return this.$store.communicationBooksStore.state.accessDenied
    },
    canOpenSelectedBook() {
      return !!this.selectedBook
        && !this.selectedBook.folio_one_created
        && this.checkPermissions(['create_communication_book_folios'])
    },
    priorityOptions() {
      return [
        { text: 'Baja', value: 1 },
        { text: 'Normal', value: 2 },
        { text: 'Alta', value: 3 },
      ]
    },
  },
  watch: {
    selectedProject(newProject, oldProject) {
      if (!newProject || newProject.id === oldProject?.id) return
      this.page = 1
      this.loadBooks()
    },
    '$route.query.folio_id'(folioId) {
      if (folioId) this.openFolioById(folioId)
    },
    accessDenied(denied) {
      if (denied) this.$router.replace({ name: 'Dashboard' })
    },
  },
  mounted() {
    this.loadBooks()
    if (this.$route.query.folio_id) this.openFolioById(this.$route.query.folio_id)
  },
  beforeDestroy() {
    this.$store.communicationBooksStore.commit('resetForProject')
  },
  methods: {
    async loadBooks() {
      if (!this.selectedProject) return
      await this.$store.communicationBooksStore.dispatch('loadBooks', this.selectedProject.id)
      this.page = 1
      this.loadFolios()
    },
    bookFilterText(book) {
      return book.id === 'all' ? 'Todos' : `${book.code?.short_code || book.code || ''} - ${book.name}`
    },
    applyBookFilter() {
      this.page = 1
      this.loadFolios()
    },
    async closeAdminModal() {
      this.adminModal = false
      await this.loadBooks()
    },
    loadFolios() {
      if (!this.selectedProject) {
        if (!this.selectedBookId) return
        return this.$store.communicationBooksStore.dispatch('loadFolios', {
          bookId: this.selectedBookId,
          page: this.page,
        })
      }
      return this.$store.communicationBooksStore.dispatch('loadFolios', {
        projectId: this.selectedProject.id,
        bookIds: this.selectedBookFilterIds,
        page: this.page,
      })
    },
    async openFolio(folio) {
      this.$store.communicationBooksStore.commit('setCurrentFolio', { loading: true })
      await this.$store.communicationBooksStore.dispatch('loadFolio', folio.id)
    },
    async openFolioById(folioId) {
      this.$store.communicationBooksStore.commit('setCurrentFolio', { loading: true })
      await this.$store.communicationBooksStore.dispatch('loadFolio', folioId)
    },
    loadDraft(draft) {
      let data = draft.data
      if (typeof data === 'string') {
        try { data = JSON.parse(data) } catch (error) { data = {} }
      }
      const bookId = data?.book_id || data?.form?.book_id
      if (bookId && this.books.some(book => book.id === bookId)) {
        this.$store.communicationBooksStore.commit('setSelectedBookId', bookId)
      }
      this.$store.communicationBooksStore.commit('setDraftToLoad', draft)
      this.$store.communicationBooksStore.commit('setCreateFolioModal', true)
    },
    publisherName(folio) {
      return folio.publisher?.info?.name || folio.publisher?.name || folio.publisher_name || '-'
    },
    formatDate(value) {
      if (!value) return '-'
      return new Date(value).toLocaleDateString('es-CL')
    },
    openOpeningFolio() {
      if (!this.canOpenSelectedBook) return
      this.$store.communicationBooksStore.commit('setOpeningBookId', this.selectedBook.id)
      this.$store.communicationBooksStore.commit('setCreateOpeningFolioModal', true)
    },
    priorityLabel(priority) {
      return this.priorityOptions.find(option => Number(option.value) === Number(priority))?.text || 'Normal'
    },
    priorityColor(priority) {
      return Number(priority) === 3 ? 'red lighten-5' : Number(priority) === 1 ? 'blue lighten-5' : 'grey lighten-3'
    },
  },
}
</script>

<style scoped>
.communication-books-page {
  background: #f5f7fb;
}

.communication-books-content {
  width: 100%;
  padding: 24px;
}

.communications-toolbar-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}

.communications-view-toggle {
  flex: 0 1 auto;
}

.book-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
  margin-left: auto;
}

.book-filter-trigger {
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}

.book-admin-button {
  flex: 0 0 auto;
  height: 32px!important;
  min-width: 0!important;
  padding: 0 12px!important;
}

.custom-button-consultas.v-btn{
  background-color: white;
  color: #2D4B95;
  opacity: 1!important;
  text-align: left;
}
/deep/ .custom-button-consultas.v-btn .v-icon,
/deep/ .custom-button-consultas.v-btn p{
  color: #2D4B95!important;
  font-size: 13px;
}
/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
/deep/ .custom-button-consultas.v-btn:hover .v-icon,
/deep/ .custom-button-consultas.v-btn:hover p,
/deep/ .custom-button-consultas.v-btn.selected .v-icon,
/deep/ .custom-button-consultas.v-btn.selected p{
  color: white!important;;
}
.custom-button-consultas.selected,
.custom-button-consultas:hover{
  background-color: #2D4B95!important
}

.communication-books-list-card {
  overflow: hidden;
}

.communication-books-table tbody tr {
  cursor: pointer;
  transition: background-color 120ms ease;
}

.communication-books-table tbody tr:hover {
  background: #f7f9fd;
}

.empty-state {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px;
}

@media (max-width: 700px) {
  .communication-books-content {
    padding: 16px 10px;
  }

  .communications-toolbar-row {
    align-items: stretch;
    flex-direction: column;
  }

  .communications-view-toggle {
    width: 100%;
    overflow-x: auto;
  }

  .book-controls {
    width: 100%;
    justify-content: flex-end;
    margin-left: 0;
  }

  .book-filter-trigger {
    max-width: 180px;
    width: 100%;
  }
}
</style>
